import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
// redux-persist
import storage from "redux-persist/lib/storage";
// slices
// import authenticationReducer from "./slices/authentication";
import schoolReducer from "./slices/school";
import materialReducer from "./slices/material";
import classReducer from "./slices/class";
import sectionReducer from "./slices/section";
import parentsReducer from "./slices/parents";
import studentReducer from "./slices/student";
import adsReducer from "./slices/ads";
import teacherReducer from "./slices/teacher";
import divisionsReducer from "./slices/divisions";
import timeSlotReducer from "./slices/timeSlot";
import notesReducer from "./slices/notes";
import settingReducer from "./slices/setting";
import samplesReducer from "./slices/samples";
import ministerialDecisionsReducer from "./slices/ministerial_decisions";
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const schoolPersistConfig = {
  key: "school",
  storage,
  keyPrefix: "redux-",
  whitelist: ["newSchoolUserInfo", "schoolInfo"],
};

const materialPersistConfig = {
  key: "material",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const classPersistConfig = {
  key: "class",
  storage,
  keyPrefix: "redux-",
  whitelist: ["classInfo"],
};

const sectionPersistConfig = {
  key: "section",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sectionInfo"],
};

const parentsPersistConfig = {
  key: "parents",
  storage,
  keyPrefix: "redux-",
  whitelist: ["selectedParent", "parentPageNumber"],
};

const studentPersistConfig = {
  key: "student",
  storage,
  keyPrefix: "redux-",
  whitelist: [
    "studentInfo",
    "getStudentBySearch",
    "studentPageNumber",
    "last_season",
  ],
};

const teacherPersistConfig = {
  key: "teacher",
  storage,
  keyPrefix: "redux-",
  whitelist: ["selectedTeacher", "teacherPageNumber", "sessions"],
};

const adsPersistConfig = {
  key: "ads",
  storage,
  keyPrefix: "redux-",
  whitelist: ["adsPageNumber"],
};

const divisionsPersistConfig = {
  key: "divisions",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const timeSlotPersistConfig = {
  key: "timeSlot",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const notesPersistConfig = {
  key: "notes",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sendingNotesPageNumber"],
};

const settingPersistConfig = {
  key: "setting",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const samplesPersistConfig = {
  key: "samples",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sampleId"],
};

const rootReducer = combineReducers({
  // authentication: authenticationReducer
  school: persistReducer(schoolPersistConfig, schoolReducer),
  material: persistReducer(materialPersistConfig, materialReducer),
  class: persistReducer(classPersistConfig, classReducer),
  section: persistReducer(sectionPersistConfig, sectionReducer),
  parents: persistReducer(parentsPersistConfig, parentsReducer),
  student: persistReducer(studentPersistConfig, studentReducer),
  ads: persistReducer(adsPersistConfig, adsReducer),
  teacher: persistReducer(teacherPersistConfig, teacherReducer),
  divisions: persistReducer(divisionsPersistConfig, divisionsReducer),
  timeSlot: persistReducer(timeSlotPersistConfig, timeSlotReducer),
  notes: persistReducer(notesPersistConfig, notesReducer),
  setting: persistReducer(settingPersistConfig, settingReducer),
  samples: persistReducer(samplesPersistConfig, samplesReducer),
  ministerial_decisions: ministerialDecisionsReducer,
});

export { rootPersistConfig, rootReducer };
